import { useDispatch } from "react-redux";
import { getAdminActivities } from "../redux/adminActivitiesSlice";
import { useState } from "react";
import TabPills from "./TabPills.jsx";

// Filtro elenco attività admin (Tutte / Pubblicate / Bozza).
// Stile unificato con le altre tab in-page via TabPills (2026-07-17).
const FILTERS = [
    { key: 'all', label: 'Tutte', query: { selectionKey: '', selectionValue: '', sortBy: '', reverse: '', page: '', pageSize: '' } },
    { key: 'published', label: 'Pubblicate', query: { selectionKey: 'isActive', selectionValue: 1, sortBy: '', reverse: '', page: '', pageSize: '' } },
    { key: 'draft', label: 'Bozza', query: { selectionKey: 'isActive', selectionValue: 0, sortBy: '', reverse: '', page: '', pageSize: '' } },
];

const AdminActivityFilter = () => {
    const dispatch = useDispatch();
    const [selectedFilter, setSelectedFilter] = useState('all');
    const handleChange = (key) => {
        const filter = FILTERS.find(element => element.key === key);
        dispatch(getAdminActivities(filter.query));
        setSelectedFilter(key);
    }

    return (
        <div className="p-4 rounded-xl">
            <TabPills tabs={FILTERS} activeKey={selectedFilter} onChange={handleChange} className="justify-center md:justify-start" />
        </div>
    )
}

export default AdminActivityFilter;
